import { SIDEBAR_MODES, SIDEBAR_SECTIONS } from "@/business-settings/constants";
import { useBusinessSettingsSidebar } from "@/business-settings/context/business-settings-sidebar-context";
import { CUSTOMER_TABS } from "@/business-settings/customers/constants";
import { CustomersTable } from "@/business-settings/customers/customers-table";
import {
  ICustomer,
  CustomerWithReferralsAndPayouts,
} from "@/customer/customer";

interface AdvocatesProps {
  customers: CustomerWithReferralsAndPayouts[];
  bottomContent?: React.ReactNode;
  isLoading?: boolean;
  manualSorting?: boolean;
  selectedCustomerId?: string;
  scrollResetKey?: string;
}

export const Advocates = ({
  customers,
  bottomContent,
  isLoading,
  manualSorting,
  selectedCustomerId,
  scrollResetKey,
}: AdvocatesProps) => {
  const { updateSidebar } = useBusinessSettingsSidebar();

  const handleRowClick = (customer: ICustomer) => {
    updateSidebar({
      section: SIDEBAR_SECTIONS.advocates,
      mode: SIDEBAR_MODES.view,
      selectedItemId: customer.id,
      isOpen: true,
    });
  };

  return (
    <CustomersTable
      customers={customers}
      isLoading={isLoading}
      manualSorting={manualSorting}
      onRowClick={handleRowClick}
      selectedCustomerId={selectedCustomerId}
      scrollResetKey={scrollResetKey}
      customerType={CUSTOMER_TABS.advocates}
      className="h-full w-full"
      bottomContent={bottomContent}
    />
  );
};
